import { Component, OnInit, Input, OnDestroy, signal } from '@angular/core';
import { APIService } from '../../shared/api.service';
import { SitePlan } from '../../classes/site-plan';
import { SiteFloorplanAsset } from '../../classes/site-floorplan-asset';
import { AssetService } from '../../shared/asset.service';
import { CalendarService } from '../../shared/calendar.service';
import { Asset } from 'app/classes/asset';

import moment from 'moment';

import { FloorplanService, SitePlanComplete } from 'app/shared/floorplan.service';
import { Subscription } from 'rxjs';
import { RangeInterface } from '../site-chart/site-chart.component';

@Component({
  selector: 'app-site-table',
  templateUrl: './site-table.component.html',
  styleUrls: ['./site-table.component.css'],
  standalone: false
})
export class SiteTableComponent implements OnInit, OnDestroy {
  isNaN: Function = Number.isNaN;
  _range = signal<RangeInterface>(null);
  subscription: Subscription;

  @Input()
  siteFloorplan: SitePlan;

  @Input()
  public set range(v: RangeInterface) {
    if (this._range()) {
      // Updating the range
      this._range.set(v);
      this.getHistory();
    } else {
      this._range.set(v);
    }
  }

  public get range(): RangeInterface {
    return this._range();
  }

  @Input()
  assets: SiteFloorplanAsset[];

  @Input()
  public set sitePlanComplete(v: SitePlanComplete) {
    this.siteFloorplan = v.sitePlan;
    this.assets = v.assets;

    this.getHistory();
  }

  startsAt: moment.Moment = moment().add(-6, 'days');
  endsAt: moment.Moment = moment();

  chartData: any;
  legends: any[] = [];
  sensorSelected: Asset;
  isLoading = signal<boolean>(false);

  constructor(public apiService: APIService, public assetService: AssetService, private calendarService: CalendarService, private floorplanService: FloorplanService) {

    let dow = moment().day();

    for (let idx = 1; idx <= 7; idx++) {
      const legend = {
        title: this.calendarService.DOW_NAMES[dow],
        dow: dow
      };
      dow--;
      if (dow < 0) {
        dow = 6;
      }
      this.legends.push(legend);
    }

    this.subscription = floorplanService.dataSubject.subscribe(data => {
      if (!data) {
        return;
      }
      switch (data.key) {
        case 'range':
          this.range = data.value;
          break;
      }
    });
  }

  ngOnInit() {
  }

  getHistory() {
    this.isLoading.set(true);

    if (!this.range) {
      return;
    }
    this.apiService
      .getSitePlanAssetHistory(this.siteFloorplan, this.range.startsAt, this.range.endsAt)
      .then(results => {
        console.log('got history');

        results.values.forEach((historyItem) => {
          this.assets.forEach(profileAsset => {
            if (profileAsset.id === historyItem.asset_id) {
              const rag = results.rags.filter(ragItem => ragItem.id === profileAsset.id && ragItem.daysAgo === historyItem.daysAgo);
              if (rag.length === 1) {
                const amber = rag[0].minOrangeAlert || rag[0].maxOrangeAlert;
                const red = rag[0].minAlert || rag[0].maxAlert;
                historyItem.rag = { amber, red, rag };
              } else {
                historyItem.rag = {};
              }
              profileAsset.history[historyItem.daysAgo] = historyItem;
            }
          });
        });

        this.isLoading.set(false);
      });
  }

  selectSensor(asset: SiteFloorplanAsset) {
    console.log('selected', asset);
    this.sensorSelected = asset;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

export type RangeTypes = "avg" | "min" | "max";
